import React from "react";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import "../../styles/components/tableHead.css";

/**
 * Komponente zur Darstellung des Headers einer Tabelle
 * @param id
 * @param headCells
 * @param onRequestSort
 * @param order
 * @param orderBy
 * @returns {JSX.Element}
 * @constructor
 */
function EASimpleTableHead({columns}) {
    const calculatedColumns = columns.map(column => typeof (column) === "string" ? {value: column} : column);

    return (
        <TableHead className="tableHead">
            <TableRow>
                {calculatedColumns.map((column, index) => (
                    <TableCell
                        key={index}
                        align={column.align ? column.align : 'left'}
                        style={column.style}
                    >
                        {column.value}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

export default EASimpleTableHead;
